<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Sign In</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                prepend-icon="mdi-account"
                name="username"
                label="Username"
                type="email"
                v-model="username"
                :rules="usernameRules"
                required
                data-cy="signinUsernameField"
              >
              </v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                data-cy="signinPasswordField"
                v-model="password"
                :rules="passwordRules"
                required
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error" class="mr-4" @click="reset">
              Reset
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!valid"
              @click="submit"
              data-cy="signinSubmitBtn"
              >Login</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import LoginLayout from "@/layouts/LoginLayout";
import { LOGIN } from "@/store/modules/actions.type";

export default {
  name: "SignIn",
  created() {
    this.$emit("update:layout", LoginLayout);
  },
  data: () => ({
    valid: true,
    email: "",
    show1: false,
    error: false,
    username: "",
    user: [],
    password: "",
    usernameRules: [
      v => !!v || "Username is required",
      v => (v && v.length >= 3) || "Username must be valid"
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 4) || "Password must be greater than 6 characters"
    ]
  }),

  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  },

  watch: {},

  // created() {},

  methods: {
    signin(payload) {
      this.$store.dispatch(LOGIN, { payload }).then(res => {
       // console.log(res)
        if (res.data.message) {
          if (!res.data.message.success)
            this.$noty.warning(res.data.message.error);
          return;
        } else {
          this.$router.push({ name: "home" });
        }
      });
    },
    submit() {
      if (this.$refs.form.validate()) {
        const payload = {
          username: this.username,
          password: this.password
        };

        this.signin(payload);
        // console.log(payload);
      }

      /* let signIn = this.signIn;
      this.$validator
        .validateAll()
        .then(function(response) {
          if (response === true) {
            signIn(payload);
          }
        })
        .catch(function(e) {});*/
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>
